import { BaseEnum } from '../../../enums/baseEnum';

const listPipeLineActionEnum: Array<PipeLineAction> = [];

export class PipeLineAction extends BaseEnum {
  static BATCH_SCREENING = new PipeLineAction(0, 'BatchScreening', 'Triagem em Lote', 'primary');
  static SCHEDULING = new PipeLineAction(1, 'Scheduling', 'Agendamento', 'info');
  static REQUEST_PRE_REGISTRATION = new PipeLineAction(
    2,
    'RequestPreRegistration',
    'Pré-cadastro digital',
    'warning'
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listPipeLineActionEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listPipeLineActionEnum;
  }

  public static getById(id: number): PipeLineAction | undefined {
    return listPipeLineActionEnum.find(item => item.id === id);
  }

  public static getBy(value: string): PipeLineAction | undefined {
    return listPipeLineActionEnum.find(item => item.value === value);
  }

  public static resolveValue(action: unknown): string {
    const rawValue = PipeLineAction.extractRawValue(action);

    if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
      return PipeLineAction.getById(rawValue)?.value || String(rawValue);
    }

    if (typeof rawValue !== 'string') {
      return rawValue == null ? '' : String(rawValue);
    }

    const trimmed = rawValue.trim();
    if (!trimmed) {
      return '';
    }

    if (/^-?\d+$/.test(trimmed)) {
      return PipeLineAction.getById(Number(trimmed))?.value || trimmed;
    }

    return PipeLineAction.getBy(trimmed)?.value || trimmed;
  }

  private static extractRawValue(action: unknown): unknown {
    if (action !== null && typeof action === 'object' && !Array.isArray(action) && 'action' in action) {
      return (action as { action?: unknown }).action;
    }

    return action;
  }
}
